<template>
	<div id="app" class="lunnar-radio">
		<div class="radio-player-container">
			<div class="radio-live">
				<div class="radio-live--badge"><span></span> LIVE</div>
			</div>

			<div class="radio-player" :class="{ 'is-voxpop': currentStation === 'voxpop' }">
				<div class="radio-player-logo">
					<img :src="require('@/assets/images/fm1-logo.png')" alt="" v-if="currentStation === 'fm1'" />
					<img :src="require('@/assets/images/voxpop-logo.png')" alt="" v-if="currentStation === 'voxpop'" />
				</div>

				<div class="radio-player-controls" @click="play">
					<span v-show="!playing">
						<img :src="require('@/assets/images/icon-play.svg')" alt="Play" class="injectable" />
					</span>
					<span v-show="playing">
						<img :src="require('@/assets/images/icon-pause.svg')" alt="Pause" class="injectable" />
					</span>
				</div>

				<div class="volume-control">
					<div class="volume-icon">
						<svg
							xmlns="http://www.w3.org/2000/svg"
							width="16"
							height="16"
							viewBox="0 0 24 24"
							fill="none"
							stroke="currentColor"
							stroke-width="2"
							stroke-linecap="round"
							stroke-linejoin="round"
						>
							<path d="M11 5L6 9H2v6h4l5 4V5z"></path>
							<path d="M15.54 8.46a5 5 0 0 1 0 7.07"></path>
							<path d="M19.07 4.93a10 10 0 0 1 0 14.14"></path>
						</svg>
					</div>
					<input type="range" min="0" max="1" step="0.01" v-model="volume" @input="updateVolume" class="volume-slider" />
				</div>
			</div>

			<div class="radio-buttons">
				<a href="#" @click.prevent="changeStation('voxpop')" v-if="currentStation === 'fm1'">
					Lurta eftir VoxPop <img :src="require('@/assets/images/voxpop-logo.png')" alt="VoxPop logo" />
				</a>
				<a href="#" @click.prevent="changeStation('fm1')" v-if="currentStation === 'voxpop'">
					Lurta eftir FM1 <img :src="require('@/assets/images/fm1-logo.png')" alt="FM1 logo" />
				</a>
			</div>
		</div>

		<audio id="radio-player-fm1" controls style="display: none">
			<source src="https://stream-secure.midlar.fo/fm1-128" type="audio/mpeg" />
			Your browser does not support the audio element.
		</audio>

		<audio id="radio-player-voxpop" controls style="display: none">
			<source src="https://stream-secure.midlar.fo/voxpop-128" type="audio/mpeg" />
			Your browser does not support the audio element.
		</audio>
	</div>
</template>

<script>
import SVGInject from './assets/js/svg-inject.min.js';

export default {
	name: 'App',
	data() {
		return {
			currentStation: 'fm1',
			playing: false,
			volume: 1,
			audioElements: {
				fm1: null,
				voxpop: null,
			},
		};
	},
	mounted() {
		SVGInject(document.querySelectorAll('img.injectable'));

		// Initialize audio elements
		this.audioElements.fm1 = document.getElementById('radio-player-fm1');
		this.audioElements.voxpop = document.getElementById('radio-player-voxpop');

		// Set initial volume
		this.audioElements.fm1.volume = this.volume;
		this.audioElements.voxpop.volume = this.volume;

		// Check URL parameters
		const urlParams = new URLSearchParams(window.location.search);
		const station = urlParams.get('station');
		if (station === 'voxpop') {
			this.changeStation('voxpop');
		}
	},
	methods: {
		changeStation(stationTag) {
			if (this.currentStation === stationTag) {
				return;
			}

			// Pause the current playing station
			this.audioElements[this.currentStation].pause();
			this.audioElements[this.currentStation].currentTime = 0;

			this.currentStation = stationTag;
			this.playing = false;

			this.resetSVG();
		},

		play() {
			if (this.playing) {
				this.audioElements[this.currentStation].pause();
				this.playing = false;
			} else {
				// Only load the stream if it's the first time playing or after a station change
				if (this.audioElements[this.currentStation].currentTime === 0) {
					this.audioElements[this.currentStation].load();
				}
				this.audioElements[this.currentStation].play();
				this.playing = true;
			}

			this.resetSVG();
		},

		updateVolume() {
			// Apply volume to both audio elements
			this.audioElements.fm1.volume = this.volume;
			this.audioElements.voxpop.volume = this.volume;
		},

		resetSVG() {
			setTimeout(() => {
				SVGInject(document.querySelectorAll('img.injectable'));
			}, 100);
		},
	},
};
</script>

<style lang="scss">
@import '@/assets/styles/styles.scss';

.volume-control {
	margin-top: 30px;
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;
}

.volume-icon {
	margin-right: 10px;
	color: #3498db;
}

.volume-slider {
	width: 32.5%;
	height: 4px;
	-webkit-appearance: none;
	appearance: none;
	background: #ddd;
	border-radius: 4px;
	outline: none;
	border: none;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1) inset;

	&::-webkit-slider-thumb {
		-webkit-appearance: none;
		appearance: none;
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: #3498db;
		cursor: pointer;
		border: 1px solid #2980b9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	}

	&::-moz-range-thumb {
		width: 14px;
		height: 14px;
		border-radius: 50%;
		background: #3498db;
		cursor: pointer;
		border: 1px solid #2980b9;
		box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
	}
}
</style>
